const e = {
  name: "Note",
  dimensions: { width: 32, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 32 40" style="enable-background:new 0 0 32 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M3,0C1.3,0,0,1.3,0,3v34c0,1.7,1.3,3,3,3h26c1.7,0,3-1.3,3-3V3c0-1.7-1.3-3-3-3H3z M30,16.4V29
			c0,0.5-0.5,1-1,1H3c-0.5,0-1-0.5-1-1v-5.2C2.3,23.9,2.6,24,3,24h19.4L30,16.4z M30,31.8V37c0,0.5-0.5,1-1,1H3c-0.5,0-1-0.5-1-1
			v-5.2C2.3,31.9,2.6,32,3,32h26C29.4,32,29.7,31.9,30,31.8z M2,21V3c0-0.5,0.5-1,1-1h26c0.5,0,1,0.5,1,1v9h-7c-1.7,0-3,1.3-3,3v7H3
			C2.5,22,2,21.5,2,21z M22,21.6V15c0-0.5,0.5-1,1-1h6.6L22,21.6z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as Note
};
